/**
 * UIState Store 類型定義
 */

import type { Component } from 'vue'

/** View 配置 */
export interface ViewConfig {
  id: string
  routeName: string
  title: string
  params?: Record<string, unknown>
  width?: number
  height?: number
}

/** Drawer 配置 */
export interface DrawerConfig {
  name: string
  title: string
  params?: Record<string, unknown>
}

/** Drawer 參數 */
export interface DrawerParameter {
  equipmentId?: string
  fieldId?: string
  [key: string]: unknown
}

/** 單一 Drawer 槽位狀態 */
export interface DrawerSlot {
  /** 槽位 ID (1-4) */
  id: number
  /** 是否顯示 */
  show: boolean
  /** 組件名稱 */
  name: string | Component
  /** 標題 */
  title: string
  /** 參數 */
  parameter: DrawerParameter
  /** 全屏模式 */
  fullBody: boolean
  /** 動態 z-index */
  zIndex: number
}

/** Drawer 類型 */
export type DrawerType = 'slot' | 'system' | 'filter' | 'selector' | 'nav'

/** Drawer 堆疊追蹤器 */
export interface DrawerStackItem {
  /** drawer 類型 */
  type: DrawerType
  /** 識別碼 */
  id: number | string
  /** z-index 值 */
  zIndex: number
}

/** 最大 Drawer 數量 */
export const MAX_DRAWERS = 4

/** z-index 基礎值 */
export const BASE_Z_INDEX = 1000

/** UI 狀態 */
export interface UIState {
  /** 當前開啟的 Views */
  views: ViewConfig[]
  /** 當前開啟的 Drawer */
  drawer: DrawerConfig | null
  /** 側邊欄是否展開 */
  sidebarExpanded: boolean
  /** 當前模式 */
  currentMode: string
}

/** UIState Store Actions */
export interface UIStateActions {
  /** 開啟 View */
  openView: (dir: string, page: string, title: string, params?: Record<string, unknown>) => void
  /** 關閉 View */
  closeView: (viewId: string) => void
  /** 開啟 Drawer */
  openDrawer: (name: string, title: string, params?: Record<string, unknown>) => void
  /** 關閉 Drawer */
  closeDrawer: () => void
  /** 切換側邊欄 */
  toggleSidebar: () => void
  /** 設定當前模式 */
  setCurrentMode: (mode: string) => void
}

/** UIState Store 完整類型 */
export type UIStateStore = UIState & UIStateActions
